import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  hotzone_pitch: require("../../../assets/wc/images/pitch_heatmap_transparent_2.png"),
  pitch: require("../../../assets/wc/images/attacking_zones_pitch.png"),
  right_arrow: require("../../../assets/svg/arrow-right.svg"),

};

export default assets;
